export default "__VITE_ASSET__B3e8K4vX__"